"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManaBalances = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Mana_1 = require("../../Mana/Mana");
var config_1 = require("../../../config");
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var ManaBalances = function (props) {
    var manaBalances = props.manaBalances, onClickBalance = props.onClickBalance;
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)('dcl', 'account-wrapper') }, manaBalances &&
        Object.keys(manaBalances).map(function (network) { return (react_1.default.createElement(Mana_1.Mana, { key: network, network: network, size: "small", className: (0, classnames_1.default)(onClickBalance && 'clickable'), title: "".concat(manaBalances[network].toLocaleString(), " MANA"), href: config_1.config.get('ACCOUNT_URL'), onClick: onClickBalance }, Number(manaBalances[network].toFixed(2)).toLocaleString())); })));
};
exports.ManaBalances = ManaBalances;
